export default Object.freeze({
    Summoning: 1,
    Story: 2,
    GrandHeroBattle: 3,
    TempestTrial: 4
})